import useBulkActions from "features/BulkActions/utils/hooks/useBulkActions";
import { BULK_ACTION_TABLES } from "features/BulkActions/BulkActions.constants";
import { RESOURCE_KEYS } from "utils/OrgPermissions";
import { app_route_keys, app_route_ids } from "constants/urlPaths";

export const useSessionBulkActions = ({
  props,
  listingUuid,
  slotUuid,
  filterValues = {},
  handleRowsSelected,
}) => {
  const listProps = {
    resource:
      app_route_ids[app_route_keys.zoom_attendance_session_participants],
    basePath:
      app_route_ids[app_route_keys.zoom_attendance_session_participants],
    hasCreate: false,
    hasEdit: false,
    hasList: true,
    hasShow: false,
    ...props,
  };

  const {
    getTableActions,
    showBroadcastModal,
    setShowBroadcastModal,
    handleRowsSelected: bulkHandleRowsSelected,
    selectedRecords,
    initiateBroadcast,
    getBroadcastActions,
    generateFooterProps,
    currentPageFullSelection,
    selectAll,
    handleSelectAll,
    total,
  } = useBulkActions(listProps);

  const broadcastActions = getBroadcastActions({
    action: ({ broadcastType }) => {
      const realSelectedIds = Object.values(selectedRecords)
        .map(
          (rec) =>
            rec?.exly_user_uuid ||
            rec?.user_uuid ||
            rec?.booking_uuid ||
            rec?.booking_id ||
            (rec?.id && isNaN(Number(rec.id)) ? rec.id : null)
        )
        .filter(Boolean);

      const { ...restFilters } = filterValues || {};
      const filterData = {
        slot_uuid: slotUuid,
        attendance_type: restFilters?.attendance_type ?? 0,
        ...restFilters,
      };

      initiateBroadcast({
        tableName: BULK_ACTION_TABLES.ZOOM_ATTENDANCE,
        broadcastType,
        listingUUID: listingUuid,
        selectedIds: realSelectedIds.length > 0 ? realSelectedIds : undefined,
        customFilterData: filterData,
      });
    },
    tableName: BULK_ACTION_TABLES.ZOOM_ATTENDANCE,
  });

  const bulkActions = getTableActions(
    RESOURCE_KEYS.SUBSECTIONS.MY_BOOKINGS.BOOKINGS
  );
  const footerProps = generateFooterProps({ bulkActions });

  const onRowSelectedHandler = (ids, records) => {
    handleRowsSelected(ids);
    bulkHandleRowsSelected(records || ids);
  };

  const handleSelectAllWrapper = (val) => {
    handleSelectAll(val);
    if (handleRowsSelected) {
      handleRowsSelected([]);
    }
  };

  return {
    showBroadcastModal,
    setShowBroadcastModal,
    broadcastActions,
    bulkActions,
    footerProps,
    selectedRecords,
    currentPageFullSelection,
    selectAll,
    handleSelectAll: handleSelectAllWrapper,
    total,
    onRowSelectedHandler,
  };
};
